export default {
      id: "more-usage",
      viewBox: "0 0 18 4",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#more",
      toString: function () {
        return this.url;
      }
    }